module.exports = __webpack_public_path__ + "media/images/selected_seats-d99f4faa191a7469b5ecaf10c2800921.svg";